/* eslint-disable  @typescript-eslint/no-explicit-any */
export const getFormValues = (context) => context?.from[0]?.value;
